/** 是否微信内置浏览器（含企微） */
export function isWechatBrowser(): boolean {
  const ua = navigator.userAgent || "";
  return /MicroMessenger/i.test(ua) || /wxwork/i.test(ua);
}

/** 是否 iOS */
export function isIOS(): boolean {
  const ua = navigator.userAgent || "";
  return /iPhone|iPad|iPod/i.test(ua);
}
